import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(getToken),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSaga);

import { call, select, put } from 'redux-saga/effects';
import { doLoadInviteAFriend, loadInviteAFriendError } from 'containers/InviteAFriend/InviteAFriend.saga';
import { pathSelector } from 'redux/saga/selectors';
export function getToken() {
  var currentPath;
  return regeneratorRuntime.wrap(function getToken$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(pathSelector);

        case 2:
          currentPath = _context.sent;

          if (!/^(\/invite\/)/.test(currentPath)) {
            _context.next = 5;
            break;
          }

          return _context.abrupt("return", /[^/]*$/.exec(currentPath)[0]);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function loadSaga(client) {
  var token;
  return regeneratorRuntime.wrap(function loadSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call(getToken);

        case 3:
          token = _context2.sent;
          _context2.next = 6;
          return call(doLoadInviteAFriend, client, {
            token: token
          });

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 12;
          return put(loadInviteAFriendError(_context2.t0));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 8]]);
}